import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), // base should be here
    routes: [
        {
            path: "/",
            name: 'BowlerChartCollection',
            component: () => import('@/components/BowlerChart/BowlerChartCollection.vue'), // Ensure the extension is included
        },
        {
            path: "/Connect",
            name: "Connect",
            component: () => import('@/components/BowlerChart/Connect.vue')
        },
        {
            path: "/edit-product",
            name: "ProductConfiguration",
            component: () => import('@/components/BowlerChart/ProductConfigurationTable.vue')
        },
        {
            path: "/bowlerChart/dashboard",
            name: 'LayoutDashboard',
            component: () => import('@/components/BowlerChart/LayoutDashboard.vue'), // Ensure the extension is included
        },
        {
            path: "/bowlerChart/application/:productId?",
            name: 'RegisteredApplication',
            component: () => import('@/components/BowlerChart/RegisteredApplication.vue'),
            props: (route) => ({
                productId: route.params.productId,
                productName: history.state?.productName || '',
                productDescription: history.state?.productDescription || '',
                productCreatedBy: history.state?.productCreatedBy || '',
                fbpOwner: history.state?.fbpOwner || ''
            })
        },
        {
            path: "/bowlerChart/user/:productId",
            name: 'UserPage',
            component: () => import('@/components/BowlerChart/UserPage.vue'),
            props: (route) => ({
                productId: route.params.productId,
                productName: history.state?.productName || '',
                productDescription: history.state?.productDescription || '',
                productCreatedBy: history.state?.productCreatedBy || '',
                fbpOwner: history.state?.fbpOwner || ''
            })
        },
        {
            path: "/bowlerChart/owner/:productId",
            name: 'OwnerPage',
            component: () => import('@/components/BowlerChart/OwnerPage.vue'),
            props: (route) => ({
                productId: route.params.productId,
                productName: history.state?.productName || '',
                productDescription: history.state?.productDescription || '',
                productCreatedBy: history.state?.productCreatedBy || '',
                fbpOwner: history.state?.fbpOwner || ''
            })
        },
        {
            path: "/unauthorized",
            name: 'Unauthorized',
            component: () => import('@/views/unAuthorized.vue')
        },
        {
            path: "/protoType",
            name: 'ProtoType',
            component: () => import('@/components/SLA/ProtoType.vue'), // Ensure the extension is included
        },
        {
            path: "/protoType2",
            name: 'ProtoType2',
            component: () => import('@/components/SLA/ProtoType2.vue'), // Ensure the extension is included
        },
        {
            path: "/feedback",
            name: 'UserFeedback',
            component: () => import('@/components/BowlerChart/UserFeedback.vue'), // Ensure the extension is included
        },
        {
            path: '/:catchAll(.*)',
            redirect: '/' // ✅ no loop
        }
    ],
})
router.beforeEach((to, from, next) => {
    if (to.path === '/unauthorized') {
        const isLegitimate = sessionStorage.getItem("unauthorizedAccess") === "true";
        sessionStorage.removeItem("unauthorizedAccess"); // ✅ always clear on entry
        if (!isLegitimate) return next({ path: '/' });
    } else {
        sessionStorage.removeItem("unauthorizedAccess"); // ✅ clear stale flag on any other navigation
    }
    next();
});

export default router

